import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const ServicesDropdown = ({ onClose, triggerRef, onMouseEnter, onMouseLeave, className }) => {
  const { t } = useTranslation("services");
  const dropdownRef = useRef(null);

  const services = ["audit", "research", "testing", "implementation", "installation", "support", "warranty"]

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose, triggerRef]);

  const handleMouseLeave = (e) => {
    const relatedTarget = e.relatedTarget;
    const dropdownElement = dropdownRef.current;
    
    if (dropdownElement && dropdownElement.contains(relatedTarget)) {
      return;
    }
    
    onMouseLeave(e);
  };

  return (
    <div 
      ref={dropdownRef}
      className={`absolute left-0 z-50 w-[300px] border-r border-white/10 bg-[rgb(42,42,42)] ${className || ''}`}
      style={{ top: '100%' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul 
        className="py-2 max-h-[45dvh] overflow-y-auto"
        onMouseEnter={onMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {services.map((service, index) => (
          <li
            key={index}
            className="relative"
            onMouseEnter={onMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button
              type="button"
              className="w-full px-4 py-3 text-left transition-all duration-200 text-white cursor-default"
              onMouseEnter={onMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <span 
                className="block text-white/80 hover:text-[#42fbfe] transition-colors"
                onMouseEnter={onMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {t(`services.${service}`)}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServicesDropdown; 